<div class="overflow-x-hidden w-full relative" style="margin-top: -2rem;">
<!-- Hero Section -->
<div class="w-full relative overflow-hidden flex flex-column align-items-center justify-content-center hero-bg-container" style="background-color: #000086; margin-top: -2rem;">
   <!-- Background image -->
   <img src="../../../assets/images/mentor_profile_hero_bg.png" class="absolute top-0 left-0 w-full h-full" style="object-fit: cover; z-index: 0; opacity: 0.9;">
   
   <div class="container_width mx-auto relative z-1 flex flex-column align-items-center justify-content-center">
      
      <!-- Mentor Profile Badge -->
      <div class="relative flex align-items-center justify-content-center mb-2 mt-6" style="height: 60px;">
         <img src="../../../assets/images/mentor_profile_brush.png" class="absolute" style="width: 256px; height: 60px; z-index: 0; object-fit: contain;">
      </div>

      <!-- Name -->
      <h1 class="text-center m-0 px-3 hero-name" style="color: #D7DA54; font-weight: 700; font-family: 'Poppins', sans-serif; line-height: 1.1;">
         {{mentor?.firstName}} {{mentor?.lastName}}
      </h1>

      <!-- Experience -->
      <p class="font-semibold mt-1 mb-5 hero-experience" style="color: #FFFDBA; font-family: 'Poppins', sans-serif;">
         {{ (mentor?.experience?.split('.')?.[0]) || 0 }}+ Years of expertise
      </p>

   </div>
</div>

<div class="container_width relative mx-auto pb-8">
    <!-- Avatar Overlay -->
    <div class="absolute flex justify-content-center lg:justify-content-start w-full lg:w-auto z-5 avatar-overlay-container">
        <div class="border-circle overflow-hidden bg-white shadow-4 flex align-items-center justify-content-center hero-avatar" style="border: 5px solid #CDD12A; background: #EAEAFF;">
            <img [src]="mentor?.imageUrl || '../../../assets/images/avatar1.jpg'" class="w-full h-full border-circle object-cover" alt="Mentor Profile">
        </div>
    </div>

    <!-- Decorative Background Elements -->
    <div class="absolute hidden lg:block" style="left: 0; top: 180px; width: 140px; height: 75px; background-image: radial-gradient(#CDD12A 2.5px, transparent 2.5px); background-size: 16px 16px; z-index: 0;"></div>
    <div class="absolute hidden lg:block" style="right: 0; top: 220px; width: 75px; height: 160px; background-image: radial-gradient(#382FE8 2.5px, transparent 2.5px); background-size: 16px 16px; z-index: 0;"></div>

    <!-- Meet the Mentor -->
    <div class="w-full flex justify-content-center pt-8 mt-5 lg:mt-7 relative z-1">
        <div class="text-center">
            <h2 class="m-0 font-bold" style="color: #000086; font-size: clamp(2.5rem, 5vw, 3.5rem); font-family: 'Poppins', sans-serif;">
                Meet the Mentor
            </h2>
            <div class="mx-auto mt-2" style="width: 120px; height: 5px; background-color: #CDD12A; border-radius: 4px;"></div>
        </div>
    </div>

    <!-- Video Section -->
    <div *ngIf="safeVideoUrl" class="w-full flex justify-content-center mt-6 mb-7 px-4 relative z-2" style="overflow: visible;">
        <!-- Dotted Curve and Plane Design Image (Full-width viewport) -->
        <img src="../../../assets/images/moving_plane.png" class="absolute hidden lg:block" 
             style="left: calc(50% - 50vw); top: -190px; width: 90vw; height: auto; pointer-events: none; z-index: 0;" alt="Plane Design">

        <div class="relative w-full z-2" style="max-width: 850px;">
            <div class="w-full relative border-round-3xl overflow-hidden" style="padding-top: 56.25%; box-shadow: -20px 20px 0px #000086;">
                <iframe class="absolute top-0 left-0 w-full h-full"
                    [src]="safeVideoUrl"
                    title="YouTube video player" frameborder="0" 
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                    referrerpolicy="strict-origin-when-cross-origin" sandbox="allow-same-origin allow-scripts allow-presentation allow-top-navigation" allowfullscreen>
                </iframe>
            </div>
        </div>
    </div>

    <div class="w-full grid grid-nogutter relative pt-6 mt-4 pb-8">
        <!-- Background rings -->
        <div class="absolute hidden lg:block border-circle" style="width: 333px; height: 333px; right: -3vw; transform: translateX(45%); top: 40px; border: 9px solid #000086; z-index: 0;"></div>
        <div class="absolute hidden lg:block border-circle" style="width: 417px; height: 417px; right: -3vw; transform: translateX(45%); top: 0px; border: 9px solid #D9DA5F; z-index: 0;"></div>

        <!-- About Header (Centered across full width) -->
        <div class="col-12 flex flex-column align-items-center justify-content-center mb-6 relative z-1">
            <h2 class="m-0 font-bold" style="color: #000086; font-size: clamp(40px, 4vw, 70px); font-family: 'Poppins', sans-serif;">
                About
            </h2>
            <div class="mt-2" style="width: 140px; height: 6px; background-color: #CDD12A; border-radius: 4px;"></div>
        </div>

        <!-- Left Column -->
        <div class="col-12 lg:col-4 xl:col-3 p-0 lg:pr-5 relative z-1 flex flex-column gap-5">
            
            <!-- Education Card -->
            <div class="w-full border-round-2xl p-5 flex flex-column gap-5 relative overflow-hidden" style="background-color: #000086;">
                <div class="flex justify-content-start">
                    <div class="px-4 py-2 border-round-3xl flex align-items-center justify-content-center" style="background: rgba(205, 209, 42, 0.18); border: 1px solid rgba(205, 209, 42, 0.30);">
                        <span class="font-semibold text-lg tracking-wide uppercase" style="color: #E1E37F; font-family: 'Poppins', sans-serif;">Education</span>
                    </div>
                </div>

                <div class="flex flex-column gap-4 mt-2">
                    <!-- Undergraduate -->
                    <div *ngIf="mentor?.graduationCollageName" class="flex gap-4 align-items-start">
                        <div class="flex-shrink-0 flex align-items-center justify-content-center pt-1" style="width: 30px;">
                            <i class="pi pi-graduation-cap text-2xl" style="color: #CDD029;"></i>
                        </div>
                        <div class="flex flex-column gap-1">
                            <span class="font-semibold text-lg text-white" style="font-family: 'Poppins', sans-serif;">Undergraduate</span>
                            <span class="font-normal text-sm text-white line-height-3" style="font-family: 'Poppins', sans-serif;">{{mentor?.graduationCollageName}}</span>
                        </div>
                    </div>

                    <!-- Post Graduate -->
                    <div *ngIf="mentor?.mastersCollageName" class="flex gap-4 align-items-start">
                        <div class="flex-shrink-0 flex align-items-center justify-content-center pt-1" style="width: 30px;">
                            <i class="pi pi-graduation-cap text-2xl" style="color: #CDD029;"></i>
                        </div>
                        <div class="flex flex-column gap-1">
                            <span class="font-semibold text-lg text-white" style="font-family: 'Poppins', sans-serif;">Post Graduate</span>
                            <span class="font-normal text-sm text-white line-height-3" style="font-family: 'Poppins', sans-serif;">{{mentor?.mastersCollageName}}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Specialisation Card -->
            <div *ngIf="mentor?.subjectSpecialization?.length || mentor?.servicesSpecialization?.length" class="w-full border-round-2xl p-5 flex flex-column gap-4 relative overflow-hidden" style="background-color: #000086;">
                <div class="flex justify-content-start">
                    <div class="px-4 py-2 border-round-3xl flex align-items-center justify-content-center" style="background: rgba(205, 209, 42, 0.18); border: 1px solid rgba(205, 209, 42, 0.30);">
                        <span class="font-semibold text-lg tracking-wide uppercase" style="color: #E1E37F; font-family: 'Poppins', sans-serif;">Specialisation</span>
                    </div>
                </div>

                <div *ngIf="mentor?.subjectSpecialization?.length" class="flex flex-column gap-2 mt-2">
                    <span class="text-xs font-semibold uppercase tracking-wider" style="color: #E1E37F; font-family: 'Poppins', sans-serif;">Subject Specialisation</span>
                    <div class="flex flex-wrap gap-2">
                        <div *ngFor="let subject of mentor?.subjectSpecialization" class="px-3 py-2 bg-white border-round-3xl font-bold" style="color: #000086; font-size: 11px;">
                            {{subject}}
                        </div>
                    </div>
                </div>

                <div *ngIf="mentor?.servicesSpecialization?.length" class="flex flex-column gap-2 mt-2">
                    <span class="text-xs font-semibold uppercase tracking-wider" style="color: #E1E37F; font-family: 'Poppins', sans-serif;">Service Specialisation</span>
                    <div class="flex flex-wrap gap-2">
                        <div *ngFor="let service of mentor?.servicesSpecialization" class="px-3 py-2 bg-white border-round-3xl font-bold" style="color: #000086; font-size: 11px;">
                            {{service}}
                        </div>
                    </div>
                </div>
            </div>

            <!-- Connect Now Card -->
            <div *ngIf="portal === 'student' && mentor?.status !== StudentMentorRequestStatus.Approved" class="w-full border-round-2xl p-5 relative" style="background-color: #D9DA5F;">
                <img src="../../../assets/images/student_connect_to_mentor.png" class="block mx-auto w-full max-w-25rem mb-4" alt="Connect Vector">
                
                <h3 class="m-0 w-full text-left line-height-3" style="font-family: 'Poppins', sans-serif;">
                    <span style="color: black; font-size: 26px; font-weight: 500;">Want to work with mentors like </span>
                    <span style="color: #000086; font-size: 26px; font-weight: 700;">{{mentor?.firstName}} {{mentor?.lastName}}?</span>
                </h3>
                
                <p class="text-left mt-3 mb-5 line-height-3" style="color: black; font-size: 16px; font-weight: 700; font-family: 'Poppins', sans-serif;">
                    Call us now to work 1-on-1 with this mentor or our extended network.
                </p>

                <ng-container [ngSwitch]="mentor?.status">
                    <p-button *ngSwitchCase="StudentMentorRequestStatus.Pending" [disabled]="true"
                        label="Pending Approval" class="w-full block" styleClass="w-full border-round-2xl py-3 border-none bg-blue-900 text-white" [style]="{'font-size': '26px', 'font-weight': '700', 'letter-spacing': '0.52px', 'box-shadow': '0px 7px 24px rgba(0, 0, 134, 0.25)'}">
                    </p-button>

                    <p-button *ngSwitchCase="StudentMentorRequestStatus.Rejected" [disabled]="true" 
                        label="Request Rejected" class="w-full block" styleClass="w-full border-round-2xl py-3 border-none bg-blue-900 text-white" [style]="{'font-size': '26px', 'font-weight': '700', 'letter-spacing': '0.52px', 'box-shadow': '0px 7px 24px rgba(0, 0, 134, 0.25)'}">
                    </p-button>

                    <p-button *ngSwitchDefault [disabled]="isAnyMentorPending || hasApprovedMentor" 
                        (click)="showDialog()" class="w-full block" styleClass="w-full border-round-2xl py-3 border-none text-white hover:bg-blue-800 transition-colors transition-duration-200" [style]="{'background-color': '#000086', 'font-size': '26px', 'font-weight': '700', 'letter-spacing': '0.52px', 'box-shadow': '0px 7px 24px rgba(0, 0, 134, 0.25)'}"
                        label="Connect Now">
                    </p-button>
                </ng-container>
            </div>
        </div>

        <!-- Right Column Placeholder -->
        <div class="col-12 lg:col-8 xl:col-9 p-0 lg:pl-5 relative z-1 flex flex-column gap-5 mt-6 lg:mt-0">
            <!-- Short Bio Card -->
            <div class="w-full bg-white border-round-2xl shadow-2 border-1 border-gray-300">
                <div class="flex align-items-center gap-3 p-4 border-bottom-1 border-gray-200">
                    <div class="flex align-items-center justify-content-center border-round-xl" style="width: 48px; height: 48px; background-color: #D3D3FF;">
                        <i class="pi pi-user text-2xl" style="color: #000086;"></i>
                    </div>
                    <span class="font-semibold text-xl" style="color: #000086; font-family: 'Poppins', sans-serif;">Short bio</span>
                </div>
                
                <div class="text-lg font-normal line-height-3 p-5" style="color: black; font-family: 'Poppins', sans-serif;" [innerHTML]="mentor?.whyToBeMentor || 'No bio provided.'">
                </div>
            </div>

            <!-- Top Admits Card -->
            <div *ngIf="mentor?.topAdmits?.length" class="w-full bg-white border-round-2xl shadow-2 border-1 border-gray-300">
                <div class="flex align-items-center gap-3 p-4 border-bottom-1 border-gray-200">
                    <div class="flex align-items-center justify-content-center border-round-xl" style="width: 48px; height: 48px; background-color: #F6D282;">
                        <i class="pi pi-building text-2xl" style="color: #946C14;"></i>
                    </div>
                    <span class="font-semibold text-xl" style="color: #000086; font-family: 'Poppins', sans-serif;">Top Admits</span>
                </div>

                <div class="flex flex-wrap gap-5 lg:gap-8 align-items-center justify-content-center lg:justify-content-start p-5">
                    <img *ngFor="let admit of mentor?.topAdmits" [src]="admit.logoUrl" [alt]="admit.instituteName" style="width: 90px; height: 90px; object-fit: contain;">
                </div>
            </div>

            <!-- Check out our Vlogs Card -->
            <div class="w-full bg-white border-round-2xl shadow-2 border-1 border-gray-300">
                <div class="flex align-items-center gap-3 p-4 border-bottom-1 border-gray-200">
                    <div class="flex align-items-center justify-content-center border-round-xl" style="width: 48px; height: 48px; background-color: #F5F682;">
                        <i class="pi pi-video text-2xl" style="color: #ACAF26;"></i>
                    </div>
                    <span class="font-semibold text-xl" style="color: #000086; font-family: 'Poppins', sans-serif;">Check out our Vlogs</span>
                </div>

                <!-- Horizontal scrolling container for vlog boxes -->
                <div class="flex overflow-x-auto gap-4 p-5 pb-4" style="scroll-snap-type: x mandatory;">
                    <div *ngFor="let _ of [1,2,3,4,5]" class="flex-shrink-0 relative border-round-2xl overflow-hidden" style="width: 269px; height: 358px; background-color: #838383; scroll-snap-align: start;">
                        <!-- Play button overlay -->
                        <div class="absolute top-50 left-50" style="transform: translate(-50%, -50%);">
                            <div class="flex align-items-center justify-content-center border-circle cursor-pointer" style="width: 48px; height: 48px; background: rgba(255, 255, 255, 0.85);">
                                <i class="pi pi-play text-xl text-black-alpha-90 pl-1"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

    <!-- Hear from the Students Section -->
    <div class="container_width mx-auto w-full pt-6 pb-8 flex flex-column align-items-center relative z-1">
        <div class="text-center relative inline-block mb-6">
            <h2 class="m-0 font-bold" style="color: #000086; font-size: clamp(40px, 4vw, 70px); font-family: 'Poppins', sans-serif;">
                Hear from the Students
            </h2>
            <div class="mx-auto mt-2" style="width: 184px; height: 6px; background-color: #D9DA5F; border-radius: 4px;"></div>
        </div>

        <!-- Horizontal Scrolling Container -->
        <div class="w-full flex overflow-x-auto gap-4 px-4 pb-5 pt-3" style="scroll-snap-type: x mandatory; -webkit-overflow-scrolling: touch;">
            <div *ngFor="let t of testimonials" class="flex-shrink-0 relative border-round-3xl p-4 md:p-5 flex flex-column justify-content-between" 
                 [style.background]="t.bgColor" 
                 [style.border]="'2px solid ' + t.borderColor"
                 style="width: 380px; scroll-snap-align: center; min-height: 420px;">
                
                <!-- Large Quote -->
                <div [style.color]="t.quoteColor" style="font-size: 60px; font-family: 'Lora', serif; line-height: 1; margin-top: 10px; font-weight: 700;">
                    "
                </div>
                
                <!-- Testimonial Text -->
                <div class="flex-grow-1 mt-3 mb-4" style="color: #424242; font-size: 15px; line-height: 1.6; font-family: 'Sora', sans-serif;">
                    {{t.text}}
                </div>

                <!-- Footer -->
                <div class="flex align-items-center justify-content-between w-full mt-auto pt-2">
                    <!-- Avatar & Name -->
                    <div class="flex align-items-center gap-3">
                        <div class="flex align-items-center justify-content-center border-circle" 
                             [style.background]="t.avatarColor" 
                             [style.color]="t.avatarTextColor"
                             style="width: 44px; height: 44px; font-size: 16px; font-weight: 800; font-family: 'Sora', sans-serif;">
                            {{t.avatarText}}
                        </div>
                        <div class="flex flex-column">
                            <span class="font-bold" style="color: #111111; font-size: 16px; font-family: 'Sora', sans-serif;">{{t.name}}</span>
                            <span style="color: #8E8E8E; font-size: 13px; font-family: 'Sora', sans-serif;">{{t.subtext}}</span>
                        </div>
                    </div>

                    <!-- Badge -->
                    <div class="px-3 py-2 border-round-3xl flex align-items-center justify-content-center"
                         [style.background]="t.badgeBgColor"
                         [style.color]="t.badgeTextColor">
                        <span class="font-bold text-xs uppercase tracking-wide" style="font-family: 'Sora', sans-serif;">{{t.badgeText}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

<p-dialog [modal]="true" [(visible)]="visible" (onHide)="visible = false" 
  [showHeader]="false" 
  [style]="{ width: '930px', maxWidth: '95vw', borderRadius: '35px', background: 'transparent', border: 'none', boxShadow: 'none' }" 
  [contentStyle]="{ background: 'transparent', padding: '0', borderRadius: '35px', overflow: 'hidden' }" 
  maskStyleClass="custom-dialog-mask">
    
  <div class="relative w-full flex flex-column overflow-hidden" style="background: linear-gradient(223deg, #000086 0%, #0909A8 100%); min-height: 650px; border-radius: 35px; padding: 50px;">
      
      <!-- Close Button -->
      <button (click)="visible = false" class="absolute cursor-pointer bg-transparent border-none text-white hover:text-gray-300 transition-colors z-5" style="top: 30px; right: 30px; font-size: 28px;">
          ✕
      </button>

      <!-- Top Section (Text + Image) -->
      <div class="flex flex-column w-full mb-6 relative z-2 flex-grow-1" style="margin-top: 20px;">
          <!-- Text Content -->
          <div class="flex flex-column w-full z-2">
              <h2 style="color: #FDFF77; font-size: 60px; font-weight: 700; line-height: 72px; margin: 0 0 20px 0;">
                  Been overthinking?<br>Drop it here.
              </h2>
              <p style="color: white; font-size: 20px; font-weight: 200; line-height: 32.4px; margin: 0; max-width: 550px; -webkit-font-smoothing: antialiased; -moz-osx-font-smoothing: grayscale;">
                  You don’t have to sort everything alone, neither do you have to have everything figured out. Just share where you’re at, and we’ll help you take the right next step.
              </p>
          </div>
          
          <!-- Paper Plane Image -->
          <div class="hidden md:flex absolute" style="right: -70px; top: 40px; z-index: 1; pointer-events: none; rotate: -0deg; width: 250px;">
              <img src="../../../assets/images/contact_up_pop_up_plane.png" alt="Paper plane" style="max-width: 350px;">
          </div>
      </div>

      <!-- Text Area Section -->
      <div class="relative w-full mt-auto z-2" style="border-radius: 14px; background: white; padding: 4px; box-shadow: 0 0 0 7px #CDD12A, -9px 6px 0 7px #CDD12A; height: 225px; margin-left: 9px; margin-bottom: 6px;">
          <textarea class="w-full border-none outline-none p-4" [(ngModel)]="purposeToConnect" rows="6" 
                    placeholder="Type your query here" 
                    style="resize: none; border-radius: 10px; font-size: 20px; line-height: 32.4px; color: #333; background: transparent; height: 100%;"></textarea>
          
          <small class="text-white block absolute font-semibold" style="bottom: -30px; left: 10px;" *ngIf="submitted && !purposeToConnect">
              Query is required
          </small>

          <!-- Send Button -->
          <button class="absolute cursor-pointer border-none text-white flex align-items-center justify-content-center" 
                  [disabled]="!purposeToConnect || isLoading"
                  (click)="requestMentor()"
                  style="bottom: 16px; right: 16px; background: linear-gradient(140deg, #883DF9 0%, #8931DB 100%); border-radius: 8px; padding: 8px 30px; font-size: 20px; font-weight: 500; line-height: 32.4px; transition: opacity 0.2s; z-index: 5;">
              <span *ngIf="!isLoading">Send</span>
              <i *ngIf="isLoading" class="pi pi-spin pi-spinner ml-2"></i>
          </button>
      </div>
  </div>
</p-dialog>

<!-- <p-overlayPanel #op [style]="{ width: '30rem' }">
  <div class="p-4 flex flex-column gap-4">
      <b class="text-left font-medium text-xl" style="color: #12263F;">Purpose</b>
      <textarea class="w-full" [(ngModel)]="purposeToConnect" rows="5" cols="30" pInputTextarea></textarea>
      <small class="text-red-500 block" *ngIf="submitted && !purposeToConnect">
          Purpose is required
      </small>
      <p-button label="Submit" [loading]="isLoading" styleClass="save_btn" (click)="requestMentor(); op.hide()"></p-button>
  </div>
</p-overlayPanel> -->
</div>
